import { render, staticRenderFns } from "./UserDetailDialog.vue?vue&type=template&id=2e4c077a&scoped=true"
import script from "./UserDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailDialog.vue?vue&type=style&index=0&id=2e4c077a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c077a",
  null
  
)

export default component.exports